<template>
  <div class="flag-savings">
    <div class="flag-savings__first">
      <span
        v-html="savedPercentage"
      />
      <span
        class="flag-savings__first-text"
        v-html="$t(firstTextKey)"
      />
    </div>
    <div class="flag-savings__second">
      <span
        v-html="savedAmount"
      />
      <span
        class="flag-savings__second-text"
        v-html="$t(secondTextKey)"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';

  @Options({
    name: 'flag-savings'
  })
  export default class FlagSavings extends Vue {

    @Prop({default: 'flags.savings.text.savedPercentage'})
    firstTextKey: string;

    @Prop({default: 'flags.savings.text.savedAmount'})
    secondTextKey: string;

    @Prop()
    savedPercentage: string;

    @Prop()
    savedAmount: string;

  }
</script>
